import React, { useState } from "react";
import { Play, X } from "lucide-react";
import { PROCESS_STEPS } from "../mock/mock";
import { useContent } from "../context/ContentContext";

export default function ProcessSection() {
  const { processSteps = PROCESS_STEPS } = useContent();
  const [active, setActive] = useState(0);
  const [videoOpen, setVideoOpen] = useState(false);

  return (
    <section className="relative py-24 lg:py-32 bg-[#0d0b09]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        {/* Left: Video / Play */}
        <div className="lg:col-span-5 relative">
          <div
            className="relative aspect-[4/5] overflow-hidden group cursor-pointer"
            onClick={() => setVideoOpen(true)}
          >
            <img
              src="https://images.pexels.com/photos/3184357/pexels-photo-3184357.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Professional Consultation"
              className="w-full h-full object-cover transition-transform duration-[2000ms] group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a]/30 to-[#0a0a0a]/70" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="relative w-24 h-24 lg:w-28 lg:h-28 rounded-full bg-[#B87333] flex items-center justify-center group-hover:scale-110 transition-transform duration-500">
                <Play className="w-8 h-8 text-[#0a0a0a] translate-x-0.5" fill="currentColor" />
                <span className="absolute inset-0 rounded-full border border-[#B87333] animate-ping opacity-60" />
              </div>
            </div>
            <div className="absolute bottom-8 left-8 right-8">
              <span className="text-[10px] tracking-[0.3em] text-[#B87333]">VIDEO</span>
              <p className="mt-2 font-serif-display text-[#f5ede1] text-2xl">
                Profesyonel Çözüm Ortağınız
              </p>
            </div>
          </div>
          <div className="absolute -bottom-6 -right-6 w-32 h-32 border border-[#B87333]/30 -z-0 hidden lg:block" />
        </div>

        {/* Right: Steps */}
        <div className="lg:col-span-7">
          <div className="flex items-center gap-3 mb-5">
            <span className="divider-line" />
            <span className="text-[11px] tracking-[0.4em] text-[#B87333]">SÜREÇLER VE ANALİZLER</span>
          </div>
          <h2 className="font-serif-display text-[#f5ede1] text-3xl md:text-4xl lg:text-5xl leading-tight mb-10 font-light">
            AR Danışmanlık olarak her adımınızda yanınızda olacağız.
          </h2>

          <div className="space-y-px bg-[#B87333]/15">
            {processSteps.map((step, i) => {
              const isActive = i === active;
              return (
                <button
                  key={i}
                  onClick={() => setActive(i)}
                  className={`w-full text-left bg-[#0d0b09] p-6 lg:p-8 transition-colors duration-500 ${
                    isActive ? "bg-[#14100c]" : "hover:bg-[#110d0a]"
                  }`}
                >
                  <div className="flex items-start gap-6">
                    <span
                      className={`font-serif-display text-3xl ${
                        isActive ? "text-[#B87333]" : "text-[#B87333]/40"
                      }`}
                    >
                      0{i + 1}
                    </span>
                    <div className="flex-1">
                      <h3
                        className={`font-serif-display text-xl md:text-2xl mb-2 transition-colors ${
                          isActive ? "text-[#B87333]" : "text-[#f5ede1]"
                        }`}
                      >
                        {step.title}
                      </h3>
                      <div
                        className={`grid transition-all duration-500 ${
                          isActive ? "grid-rows-[1fr] opacity-100 mt-2" : "grid-rows-[0fr] opacity-0"
                        }`}
                      >
                        <div className="overflow-hidden">
                          <p className="text-[#a89a85] leading-relaxed">{step.desc}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Video Modal */}
      {videoOpen && (
        <div
          className="fixed inset-0 z-[70] bg-black/90 flex items-center justify-center p-4"
          onClick={() => setVideoOpen(false)}
        >
          <button
            className="absolute top-6 right-6 text-[#f5ede1] hover:text-[#B87333]"
            onClick={() => setVideoOpen(false)}
            aria-label="Close"
          >
            <X className="w-8 h-8" />
          </button>
          <div className="relative w-full max-w-5xl aspect-video" onClick={(e) => e.stopPropagation()}>
            <iframe
              className="w-full h-full"
              src="https://www.youtube.com/embed/5qap5aO4i9A?autoplay=1"
              title="Video"
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </section>
  );
}
